import { setupModeColors } from "../../SetupMode/colors";
import React from "react";
import { css } from "@linaria/core";
import Switch from "@ui/Switch";
import TooltipV2 from "@ui/TooltipV2";
import { spacings } from "@ui/Theme";
import t from "../../../i18n";

export default function SetupCommentToggle({
  checked,
  onChange,
  disabled = false,
}: {
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
}) {
  return (
    <TooltipV2 className={setupCommentTooltip} overlay={t("comments.setup.tooltip")}>
      <Switch
        className={setupCommentToggle}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        position="right"
      >
        {t("comments.setup.label")}
      </Switch>
    </TooltipV2>
  );
}

const setupCommentTooltip = css`
  && {
    max-width: 265px;
  }
`;

const setupCommentToggle = css`
  margin-top: ${spacings.xs};
  width: fit-content;

  && input:checked:not(:disabled) ~ [role="button"],
  &&&:hover input:checked:not(:disabled) ~ [role="button"] {
    background-color: ${setupModeColors.primary};
  }
`;
